/**
 * Helpers to format providers values from server.
 * The formatting follows these rules:
 * - For EFKA provider: Converts "ΕΦΚΑ" to "e-ΕΦΚΑ"
 * - For TEKA provider: Keeps the original shortForeasName
 * - For other providers: Prepends "τ." to the shortForeasName
 *
 * IMPORTANT NOTE: PROVIDERS AND INSTITUTIONS REFER TO THE SAME ENTITIES.(ΕΦΚΑ, ΤΕΚΑ, etc.)
 * AND ARE TWO TERMS THAT ARE USED INTERCHANGEABLY IN THE APPLICATION.
 */

interface Provider {
  shortForeasName: string;
  foreasId: string;
}

interface TextValue {
  text: string;
  value: string;
}

const EFKA_PRESENTATION_VALUE = 'e-ΕΦΚΑ';
const EFKA_SERVER_VALUE = 'ΕΦΚΑ';
const TEKA_SERVER_VALUE = 'ΤΕΚΑ'; // greek characters

// Debts Contributions
const EFKA_NON_SALARIED_SERVER_VALUE = 'Ε.Φ.Κ.Α. ΜΗ ΜΙΣΘΩΤΩΝ';

// Current Contributions
const E_EFKA_SERVER_VALUE = 'e-ΕΦΚΑ';

export const formatProviderOption = (provider: Provider): TextValue => {
  switch (provider.shortForeasName) {
    case EFKA_SERVER_VALUE: // ΕΦΚΑ -> e-ΕΦΚΑ
      return { text: EFKA_PRESENTATION_VALUE, value: provider.foreasId };
    case TEKA_SERVER_VALUE: // ΤΕΚΑ -> stays the same
      return { text: provider.shortForeasName, value: provider.foreasId };
    default: // Other providers -> τ. + shortForeasName
      return { text: `τ.${provider.shortForeasName}`, value: provider.foreasId };
  }
};

export const formatProvider = (name: string): string => {
  switch (name) {
    case EFKA_SERVER_VALUE: // ΕΦΚΑ -> e-ΕΦΚΑ
      return EFKA_PRESENTATION_VALUE;
    case TEKA_SERVER_VALUE: // ΤΕΚΑ -> stays the same
    case EFKA_NON_SALARIED_SERVER_VALUE:
    case E_EFKA_SERVER_VALUE:
      return name;
    default: // Other providers -> τ. + provider
      return `τ.${name}`;
  }
};
